// extracted by mini-css-extract-plugin
module.exports = {"component":"ServiceTerms_component__3B5Gx","link":"ServiceTerms_link__2jIhY"};